export const lang = {
    lang: '英文',
    lang1: '中文',
    login:{
        OnlineTrainingSystem:"在线培训系统",
        Login:"登录",
        userName:"用户名",
        password:"密码",
        ForgetPassword:"忘记密码",
        RegisterNow:"立即注册",
        // 
        RetrievePassword:"找回密码",
        ReturnLogin:"返回登录",
        EnterName:"请输入用户名",
        Eamil:"邮箱",
        EnterEmail:"请输入邮箱",
        vCode:"验证码",
        vCodeTxt:"填写邮箱获取的验证码",
        get_vCode:"获取验证码",
        error_vCode:"验证码错误",
        setNewPassword:"设置新密码",
        enterPassword:"请输入密码",
        confirmPassword:"确认密码",
        inconsistentPassword:"两次密码请保持一致",
        Confirm:"确认",
        Register:"注册",
        GoLogin:"已有账号？去登录",
        SelectIdentity:"选择身份",
        required:"此为必填项",
        userName:"用户名",
        maxTen:"不超过十个字符",
        setPassword:"设置密码",
        checkNo:"密码至少六位，可包含字母、符号或数字",
        agree:"我已阅读并同意",
        agreement:"用户协议",
        crew:"船员",
        EngineerTrainee:"工程师学员",
        samePassword:"两次密码请保持一致",

        PerfectData:"完善资料",
        RealName:"真实姓名",
        requiredName:"此为必填项，请填写您的真实姓名。",
        Sex:"性别",
        man:"男",
        woman:"女",
        retrievePassword:"用来确认您的身份，找回密码。",
        CrewCompany:"船员公司",
        vesselName:"船只名称",
        Submit:"提交",
    },
    // 注册
    Register:{
        check_name:"用户名不可为空",
        check_email:"邮箱不可为空",
        check_code:"验证码不可为空",
        check_password:"密码不可为空",
        check_password_:"密码不一致",
        check_agreement:"请阅读并同意《用户协议》",
        check_realName:'真实姓名不得为空'
    },

    // 公共
    footer1:'北京海兰信数据科技股份有限公司',
    footer2:'京公安网安备',
    Notice:"公告",
    title:"北京海兰信数据科技股份有限公司入口！",
    Home:"首页",
    Course:"选课中心",
    Question:"题库练习",
    Personal:"个人中心",
    // 首页
    home: {
        AllCourses:"全部课程",
        SeeMore:"查看更多",
        enteredFor:"免费报名",
        Question:"题库练习",
    },
    
    // 选课中心
    course: {
        Selection: "选课中心",
        enter:"请输入内容",
        enteredFor:"免费报名",
        CurrentLocation:"当前所在位置：",
        Home:"首页",
        StudyEmploymentGuidanceCourses:"学习就业指导课程",
        classification:"分类",
        type:"类型",
        lecturer:"讲师",
        hours:"学时",
        NumberOfStudents:"学习人数",
        Learned:"已学",
        LastStudyTime:"上次学习时间",
        study:"学习至",
        StartLearning:"开始学习",
		ContinueLearning:"继续学习",
        RelatedCourses:"相关课程",
        CourseIntroduction:"课程简介",
        CourseCatalogue:"课程目录",
        AfterClassPractice:"课后练习",
        FinalExamination:"结课考试",
        enclosure:"附件",
        QA:"问答",

        mattersNeedingAttention:"注意事项:",
        PassCondition:"通过条件:",
        ExamExercise:"考试练习:",
        text1:"课程所有课件的平均进度达到100%时便可通过课程",
        text2:"本课程没有考试、没有练习",

        CoursewareName:"课件名称",
        classification:"分类",
		desc:"简介",
        duration:"时长",
        progress:"进度",
        credit:"学分",
        CurrentPlayback:"当前播放：",
        LastLecture:"上一讲",
        NextLecture:"下一讲",

        StartPracticing:"开始练习",

        examination:"参加考试",
		

        AttachmentName: "附件名称",
        fileSize:"文件大小",
        UploadTime:"上传时间",

        altogether:"共",
        individual:"个",
        problem:"问题",
        question:"我要提问",
        answer:"回答",
        browse:"浏览",
        FromCourse:"来自课程：",
        Questioner:"提问者：",
        QuestionTime:"提问时间：",

        Describe:"用一句话描述你的问题, 不超过100字",
        Cancel:"取消",
        Confirm:"确认",

        AddAnswer:"添加回答",
        SubmitAnswer:"提交回答",
        answers:"条回答",
        reply:"回复",
        adopt:"采纳",
		Adopted:"已采纳",
        delete:"删除",
		// 
		minute:'分钟',
		TotalScore:'总分',
		PassingScore:'及格分数',
		Score:'分',
		updated_at:'更新时间',
		NumberExercises:'练习次数',
		TotalNumberQuestions:'总题数',
		QuestionsUnit:'题',
    },

    // 题库练习
    question:{
        Selection: "题库练习",
        UpdateTime:"更新时间：",
        Browse:"浏览：",
		ConfirmSubmit:'确认提交',
		reportTitle:'您本次练习正确率为：',
		reportTxt:'恭喜您，再接再厉！'
    },

    // 个人中心
    personal:{
        Gender:"性别：",
        Department:"所属部门：",
        RegistrationTime:"注册时间：",
        credit:"学分",
        ClassHours:"学时",
        CompletedCourse:"已完成课程",
        NumberOfExaminations:"考试次数",

        BasicInformation:"基本资料",
        MyCourse:"我的课程",
        MyExam:"我的考试",
        MyRrades:"我的成绩",
        MyRractice:"我的练习",
        MyCredits:"我的学分",
        MyCertificate:"我的证书",
        MyNews:"我的消息",
        QA:"我的问答",

        user: {
            EditData:"编辑资料",
            ChangePassword:"修改密码",
            ModifyMailbox:"修改邮箱",
            edit:"编辑",
            RealName:"真实姓名：",
            Gender:"性别：",
            male:"男",
            woman:"女",
            IdentityLnformation:"身份信息：",
            Credits:"学分：",
            ClassHours:"学时：",
            minute:"分钟",
            RegistrationTime:"注册时间：",
            LastLoginIP:"上次登录IP：",
            LastLoginTime:"上次登录时间：",
            SetPhotos:"设置头像：",
            UploadAvatar:"上传头像",
            RecommendedSize:"建议尺寸：",
            pixel:"像素",
            preservation:"保存",

            OldPassword:"旧密码：",
            NewPassword:"新密码：",
            ConfirmPassword:"确认密码：",
            VerificationCode:"验证码：",

            OldEmailAddress:"旧邮箱地址：",
            NewEmailAddress:"新邮箱地址：",
            LoginPassword:"登录密码：",
        },

        course:{
            RecentLearning:"最近学习",
            CourseStarted:"待开始课程",
            CompletedCourse:"已完成课程",
            courses:"您还没有任何课程哦",
            EnterTheCourse:"进入课程",
        },

        examination:{
            ToTakeTheExam:"待参加考试",
            FailedToPassTheAudit:"未通过审核",
            Approved:"已通过审核",
            ExamCompleted:"已完成考试",
            TotalScore:"总分",
            ApplyForRegistration:"申请报名",
			Retest:"重新考试",
        },

        report:{
            report:"我的成绩单",
            ExaminationTime:"考试时间：",
            participants:"参加次数",
            AnswerTime:"答卷用时：",
            ViewTestPaper:"查看试卷",
            minute:"分",
            pass:"及格",
            fail:"不及格",
        },

        exercises:{
            MyPractice:"我的练习",
            UpdateTime:"更新时间：",
            Browse:"浏览：",
            TotalQuestions:"总题数：",
            StartPracticing:"开始练习",
        },

        gradePoint:{
            MyExam:"我的考试",
            TotalCredits:"总学分：",
            creditSource:"学分来源",
            creditSourceType:"学分来源类型",
            GetCredit:"获得学分",
            GetTime:"获得时间",
        },
        
        certificate:{
            MyCertificate:"我的证书",
            TotalCertificates:"证书总数量：",
            AddCertificate:"添加新证书",
            CertificateName:"证书名称",
            CertificateNo:"证书编号",
            GetTime:"获得时间",
            TermValidity:"有效期限",
            operate:"操作",
            ViewCertificate:"查看证书",
            DeleteCertificate:"删除证书",
    
            UploadCertificate:"上传个人证书",
            ClickImage:"点击上传证书图片",
            PictureRequirements:"图片要求：",
            text1:"1.建议图片尺寸为",
            text2:"2.图片大小不超过",
            text3:"3.图片格式仅限于为",
            IssuingAuthority:"发证机构：",
            ValidityCertificate:"证书有效期限：",
            CertificateDescription:"证书描述：",
            cancel:"取消",
            preservation:"保存",
        },

        message:{
            MyNews:"我的消息",
            Congratulations:"恭喜您的课程",
            Completed:"已完成，",
            GetCredits:"获得学分",
            Source:"来源：",
            Published:"发布时间：",
        },

        questions:{
            MyQuestion:"我的提问",
            answer:"回答",
            browse:"浏览",
            sourceCourse:"来自课程：",
            Questioner:"提问者：",
            QuestionTime:"提问时间：",
            QA:"我的问答",
        },

    },

    // 考试
    examination:{
        examinee:"考生：",
        Gender:"性别：",
        belongTo:"所属组：",
        CertificateNo:"证件号码：",
        essentialInformation:"基本信息",
        Total:"试题总分：",
        PassingScore:"及格分数：",
        TotalQuestions:"试题总数：",
        TotalTime:"考试限时：",
        minute:"分钟",
        examinationExplain:"考试须知",
        AttentionCandidates:"各位考生请注意：",
        text1:"1、进入考试页面点击“开始考试”即正式答题；",
        text2:"2、进行答题时请注意考试页面的倒计时，时间结束系统将强制提交试卷，请注意考试时间安排；",
        text3:"3、考试过程中请勿随意切换屏幕界面，造成任何后果由考生自行负责；",
        text4:"4、最终考试成绩以试卷提交成功为准。",
        text5:"祝各位考出好成绩！",
        Start:"开始考试",

        back:"返回",
        submit:"交卷",
        Score:"分值",
        AnswerSheet:"答题卡",
        haveFinished:"已做",
        unfinished:"未做",
        SubmissionReminder:"交卷提醒",
        txt1:"本次考试总题数为",
        txt2:"您已答试题",
        txt3:"未答试题",
        txt4:"是否确定提交试卷？",
        cancel:"取消",
        confirm:"确认",

        report:{
            result:"您本次考试成绩为：",
            Congratulations:"恭喜您，考试及格！",
			comfort:"很遗憾，您未及格，继续加油吧！",
            Examination:"考试解析",
            txt1:"本次试卷满分为100分，及格分数为60分。",
            txt2:"1、单选题：",
            txt3:"2、多选题：",
			txt4:"3、判断题：",
            Total:"总分：",
            StartTime:"开始时间：",
            SubmissionTime:"交卷时间：",
            ExaminationTime:"考试用时：",
            minute:"分",
            second:"秒",
            ViewAnswerAnalysis:"查看答案解析",
        },

        analysis:{
            Score:"分值",
            WrongAnswer:"答错了",
            correct:"答对了",
            StudentAnswer:"学员答案：",
            StandardAnswer:"标准答案：",
            Score1:"得分：",
            Analytic:"解析：",
            ExaminationFocus:"考点：",
            AnswerSheet:"答题卡",
            correct1:"正确",
            error:"错误",
            NotDone:"未做",
            Your:"您本次考试成绩为：",
            Congratulations:"恭喜您，考试及格！",
            Back:"返回"
        }
    },
	out: "退出",
	Label_classification:'标签分类',
	Course_type:'课程类型',
	Course_classification:'课程分类',
	// xx:'xx',
	unit:{
		dao:'道'
	}
}
